import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import { localesES } from './locales/es'
import { localesEN } from './locales/en'

Vue.config.productionTip = false
i18next.init({
  lng: 'es',
  resources: {
    es: { translation: localesES },
    en: { translation: localesEN }
  }
})

Vue.use(I18NextVue, { i18next })

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
